module.exports = __webpack_public_path__ + "static/media/box-login.82dff7d4.jpg";